import { styled } from '@mui/system';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { BackToLogin } from '@mgm/common/components';

import { Crisp } from 'crisp-sdk-web';
import { Page } from './Page';
import appLogo from '../assets/appLogo.png';
import errorImg from '../assets/error.png';
import { PAGES_ANALYTICS_TITLES } from '../utils/enums';

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(5),
  },
  paddingBottom: theme.spacing(10),
}));

const Error = () => {
  const { t } = useTranslation(['common', 'warning', 'welcome']);
  const navigate = useNavigate();

  const contactSupport = () => {
    Crisp.chat.open();
  };

  return (
    <>
      <Box p={4} display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <img src={appLogo} width={70} height={70} alt="appLogo" />
        </Box>
        <BackToLogin NavLinkComponent={NavLink as never} btnText={t('backToLogin', { ns: 'welcome' })} />
      </Box>
      <RootStyle title={PAGES_ANALYTICS_TITLES.ERROR}>
        <Container>
          <Box sx={{ maxWidth: 480, margin: 'auto' }} />
          <Typography textAlign="center" variant="h3" paragraph>
            {t('serverError', { ns: 'warning' })}
          </Typography>
          <Typography textAlign="center" sx={{ color: 'text.secondary' }}>
            {t('thereIsAnError', { ns: 'warning' })}
          </Typography>
          <Box display="flex" justifyContent="center">
            <img src={errorImg} height={300} alt="error" />
          </Box>
          <Stack justifyContent="center" flexDirection="row" alignItems="center">
            <Button onClick={contactSupport} sx={{ mr: 2 }} variant="contained">{t('contactSupport')}</Button>
            <Button onClick={() => navigate(-1)} variant="outlined">{t('tryAgain', { ns: 'warning' })}</Button>
          </Stack>
        </Container>
      </RootStyle>
    </>
  );
};
export { Error };
